import { useAppDispatch, useAppSelector } from "app.hook";
import moment from "moment";
import * as React from "react";
import { useHistory } from "react-router";
import { ModalComponent } from "shared/components/modal/modal";
import { ORDER_SUCCESS_ROUTE } from "shared/constants/routes";
import { selectSignIn, setLoading, showError } from "states/global-value/global-value.slice";
import { confirmCheckoutAPI, confirmCheckoutGuestAPI } from "states/order/order.api";
import {
  ICardInfoModel,
  IConfirmCheckoutGuestModel,
  IConfirmCheckoutModel,
} from "states/order/order.models";
import { setConfirmCheckoutSuccessModel } from "states/order/order.slice";
import { clearShoppingCart, clearShoppingCartGuest, selectGuestCustomerInfo } from "states/shopping-cart/shopping-cart.slice";
import imgCard from "../../../themes/img/payment.jpg";
import { shallowEqual, useSelector } from "react-redux";
interface IPaymentModal {
  isModal: boolean;
  billingAddressId: number;
  orderId: string;
  requestPickUpTime: Date;
  closeModal: (isResetModal: boolean) => void;
  onSuccess: () => void;
}
export const PaymentModal = ({
  isModal,
  orderId,
  requestPickUpTime,
  billingAddressId,
  closeModal,
  onSuccess,
}: IPaymentModal) => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const isLogged = useSelector(selectSignIn, shallowEqual);
  const guestCustomerInfo = useAppSelector(selectGuestCustomerInfo, shallowEqual);
  const [cardModel, setCardModel] = React.useState<ICardInfoModel>({
    expiredMonth: "01",
    expiredYear: moment().format("YY"),
  } as ICardInfoModel);
  const handleCheckout = async () => {
    dispatch(setLoading(true));
    //TODO://Refactor hard code payment gateway
    try {
      if (isLogged) {
        const res = await confirmCheckoutAPI({
          cardInfo: cardModel,
          orderId: orderId,
          billingAddressId: billingAddressId,
          requestPickUpTime: requestPickUpTime,
          paymentGatewayCode: "MxMerchant",
        } as IConfirmCheckoutModel);
        dispatch(setConfirmCheckoutSuccessModel(res.data));
      } else {
        const res = await confirmCheckoutGuestAPI({
          cardInfo: cardModel,
          orderId: orderId,
          billingAddress: guestCustomerInfo,
          requestPickUpTime: requestPickUpTime,
          paymentGatewayCode: "MxMerchant",
        } as IConfirmCheckoutGuestModel);
        dispatch(setConfirmCheckoutSuccessModel(res.data));
      }
      if (isLogged) {
        await dispatch(clearShoppingCart());
      } else {
        await dispatch(clearShoppingCartGuest());
      }
      closeModal(false);
      onSuccess();
      history.push(`${ORDER_SUCCESS_ROUTE}`);
      dispatch(setLoading(false));
    } catch (err) {
      dispatch(showError(err.response?.data?.error?.message));
      if (err.response?.data?.error?.code === "InvalidTime") {
        closeModal(true);
      }
      dispatch(setLoading(false));
    }
  };
  const renderExpirationMonth = () => {
    let results = [];
    results = moment.months().map((m, i) => (
      <option key={i} value={moment().month(m).format("MM")}>
        {m}
      </option>
    ));
    return results;
  };
  const renderExpirationYear = () => {
    let results = [];
    let currentYear = moment().format("YYYY");
    let futureYear = Number(currentYear) + 20;
    while (Number(currentYear) < futureYear) {
      results.push(
        <option
          key={Number(currentYear)}
          value={moment(currentYear, "YYYY").format("YY")}
        >
          {currentYear}
        </option>
      );
      currentYear = (Number(currentYear) + 1).toString();
    }
    return results;
  };
  return (
    <React.Fragment>
      <ModalComponent
        width={`100%`}
        height={`100%`}
        isModal={false}
        className="w-full bg-white rounded-2xl"
        isCustomizeFooter={true}
        onCloseModal={() => {
          closeModal(false);
        }}
        isOpenModal={isModal}
        title={`Payment`}
      >
        <div className="pt-3">
          <div className="text-base flex content-center items-center space-x-1 information-location uppercase mb-2">
            <span>CREDIT CARD</span>
            <div className="img">
              <img src={imgCard} alt="" height="auto" />
            </div>
          </div>
          <div className="form-group-card space-y-2">
            <div className="form-card">
              <div className="text-base uppercase font-semibold mb-2">
                CARD NUMBER *
              </div>
              <input
                type="text"
                value={cardModel.cardNumber ?? ""}
                placeholder="Enter your card number"
                className="rounded-md px-2 py-1 w-full border border-gray-300"
                onChange={(ev) => {
                  setCardModel({ ...cardModel, cardNumber: ev.target.value });
                }}
              />
            </div>
            <div className="text-base uppercase font-semibold mb-2">
              EXPIRATION MONTH - YEAR *
            </div>
            <div className="form-card-divide flex justify-between space-x-2 ">
              <select
                onChange={(ev) => {
                  setCardModel({ ...cardModel, expiredMonth: ev.target.value });
                }}
                value={cardModel.expiredMonth}
                className="rounded-md outline-none px-2 py-1 w-full border border-gray-300"
              >
                {renderExpirationMonth()}
              </select>
              <select
                onChange={(ev) => {
                  setCardModel({ ...cardModel, expiredYear: ev.target.value });
                }}
                value={cardModel.expiredYear}
                className="rounded-md outline-none px-2 py-1 w-full border border-gray-300"
              >
                {renderExpirationYear()}
              </select>
            </div>
            <div className="form-card">
              <div className="text-base uppercase font-semibold mb-2">
                CCV CODE *
              </div>
              <input
                type="text"
                value={cardModel.cvv ?? ""}
                placeholder="Enter your ccv code"
                className="rounded-md px-2 py-1 w-full border border-gray-300"
                onChange={(ev) => {
                  setCardModel({ ...cardModel, cvv: ev.target.value });
                }}
              />
            </div>
          </div>
        </div>
        <button
          onClick={handleCheckout}
          className="btn--primary mt-4 w-full px-8 py-2 uppercase font-semibold"
        >
          Checkout
        </button>
      </ModalComponent>
    </React.Fragment>
  );
};
